jQuery( document ).ready( function() {

	var links = jQuery( "body a[href]");
	var i = 0;
	var link;
	var query = document.location.search.replace( /\?/, '' );
	var qItems = [];

	// Parameters that need to be ignored
	var ignoreParams = [
		// WordPress search
		's',
		// page_id
		'page_id',
		// preview
		'preview',
		// Correlation ID that gets added by DFG forms on successful submission redirect
		'correlationId',
		// Used in blog search
		'blog_category',
		// Used in news search
		'news_category',
		'post_type',
		'modal',
		// Used in Media Library
		'pg',
		'gh_jid',
		// Loan calculator
		'amount',
		'drawdown',
		'term'
	];

	if ( query !== '' ) {

		qItems = query.split('&');

		// Exclude the parameters that do not need to be added to all links on the current page
		var qItemsWhitelisted = [];
		for (var ii in qItems) {
			var ignoreParameter = false;
			for (var j in ignoreParams) {
				var ignoreParamsRegex = new RegExp('^' + ignoreParams[j] + '((=.*)|)$');
				if (ignoreParamsRegex.test(qItems[ii]) === true) {
					ignoreParameter = true;
					break;
				}
			}
			if (!ignoreParameter) {
				qItemsWhitelisted.push(qItems[ii]);
			}
		}

		qItems = qItemsWhitelisted;

		var currentPage = window.location.hostname + window.location.pathname;

		// Look through all links found on the page
		while( link = links[ i++ ] ) {
			var prefix = '', set, href = link.href, x = 0, it;
			if (href.indexOf(currentPage + '?') == -1 && !href.includes('wp-admin')) {
				var hash = '';
				if ( href ) {
					href += href.search(/\?/) === -1 ? '?' : href.search(/\&/) === -1 ? '&' : '';
					// Check if there is a hash in URL
					if ( href.search( /#/ ) !== -1 ) {
						// # is found in the URL
						var temp = href.split( '#' );
						href = temp[ 0 ];
						hash = temp[ 1 ];
						if (hash.charAt(hash.length-1) == '?') {
							hash = hash.substring(0, hash.length - 1);
							href = href + '?';
						}
					}

					while( it = qItems[ x++ ] ) {
						prefix = '&';
						set = it.split( '=' );
						if ( set && set.length ) {
							href += href.search(set[0] + '=') === -1 ? !!href.split('?')[1] ? prefix + it : it : '';
						}
					}

					if (hash) {
						href += '#' + hash;
					}
					var processHref = href.split('?');
					link.setAttribute('href', !processHref[1] ? processHref[0] : href);
				}
			}
		}
	}

} );